export default {
  namespaced: true,
  state: {
    authenticated: false,
    user: {},
    providers: [],
    errors: {},
  },
  getters: {
    loggedIn: state => state.authenticated,
    subject(state) {
      return state.authenticated ? Vue.$auth.getPayload().subject : null
    },
    role(state) {
      return state.authenticated ? Vue.$auth.getPayload().role : 'guest'
    },
    fullName: state => {
      return state.user.id && state.user.firstName
        ? `${state.user.firstName} ${state.user.lastName}`
        : 'Anonymous'
    },
    email: state => (state.user.id ? state.user.email : 'Unknown'),
    user: state => state.user,
    providers: state => state.providers,
  },
  mutations: {
    authenticated: (state, authenticated) => (state.authenticated = authenticated),
    setUser: (state, user) => (state.user = user),
    setProviders: (state, providers) => (state.providers = providers),
    setErrors: (state, errors = {}) => (state.errors = errors),
  },
  actions: {
    refresh({ commit, state }) {
      if (Vue.$auth.isAuthenticated()) {
        commit('authenticated', true)
        Vue.$http.get(Vue.$auth.getPayload().sub).then(response => {
          commit('setProviders', Vue.$auth.getPayload().providers || [])
          commit('setUser', response.data)
          // Context for Sentry (no longer possible)
          // Vue.$sentry.setUser({
          //   id: state.user.id,
          //   email: state.user.email,
          //   username: `${state.user.firstName} ${state.user.lastName}`,
          //   role: Vue.$auth.getPayload().role,
          // })
          // Context for Crisp
          $crisp.push(['set', 'user:email', [state.user.email]])
          $crisp.push(['set', 'user:nickname', [`${state.user.firstName} ${state.user.lastName}`]])
        })
      }
    },
    register({ commit, dispatch }, auth) {
      commit('setErrors', {})
      return Vue.$http.post('candidates', auth)
    },
    login({ commit, dispatch, state }, { auth }) {
      return Vue.$auth
        .login(auth)
        .then(
          // Login success
          response => {
            // Vue.$http.post('sessions') // TODO: Provide some session details
            if (response.status === 204) {
              // User doesn't exist
              commit(
                'snackbar',
                {
                  text: "You couldn't be logged in. Please check the login details again.",
                  type: 'error',
                },
                { root: true }
              )
              throw response
            } else {
              dispatch('refresh')
            }
          },
          // Login failure
          errors => {
            const isBlocked = errors && errors.response && errors.response.data && errors.response.data.isBlocked
            commit(
              'snackbar',
              {
                text: isBlocked
                  ? 'Your profile has been blocked. Please contact support.'
                  : "You couldn't be logged in. Please check the login details again.",
                type: 'error',
              },
              { root: true }
            )
            throw errors
          }
        )
        .catch(errors => {
          const isBlocked =
            errors && errors.response && errors.response.data && errors.response.data.isBlocked
          commit(
            'snackbar',
            {
              text: isBlocked
                ? 'Your profile has been blocked. Please contact support.'
                : "You couldn't be logged in. Please check the login details again.",
              type: 'error',
            },
            { root: true }
          )
          throw errors
        })
    },
    logOut({ getters, commit }) {
      // Vue.$http.delete('sessions') // TODO: Provide some session details
      const role = getters['role']
      const clearDetails = function() {
        // Update state to refresh getters
        commit('authenticated', Vue.$auth.isAuthenticated())
        commit('setUser', {})
        commit('setProviders', [])
        // Vue.$sentry.setUser({})
        $crisp.push(['do', 'session:reset'])

        // Clear profile and applications for candidates
        commit(
          'candidate/profile/set',
          {
            id: null,
            countryOfBirth: '',
            identification: '',
            firstNames: '',
            lastName: '',
            bornAt: null,
            gender: null,
            biography: null,
            mobileNumber: '',
            errors: {},
          },
          { root: true }
        )
        commit('candidate/applications/setAll', [], { root: true })
        commit('candidate/experiences/setAll', [], { root: true })
        commit('candidate/profileQualifications/setAll', [], { root: true })
        commit('candidate/eligibilities/setAll', [], { root: true })

        // Clear organization and opportunities for clients
        commit('client/organization/set', { id: null, name: '' }, { root: true })
        commit('client/opportunities/setAll', [], { root: true })

        // Clear the token since `logout()` doesn't do it
        window.localStorage.removeItem('vue-authenticate.vueauth_token');
      }
      Vue.$auth.logout().then(clearDetails).catch(clearDetails)
    },
    provider({ dispatch }, { provider, campaignId = null }) {
      // VueAuthenticate sets the token when you authenticate with OAuth
      // so we want to store the Leaply JWT if it exists so we can restore
      // it before submitting credentials to the server. The only token we
      // want in headers is the Leaply JWT.
      const alreadyAuthenticated = Vue.$auth.isAuthenticated()
      return Vue.$auth.authenticate(provider).then(
        // Successful authentication
        async response => {
          if (campaignId) {
            await Vue.$http.patch(Vue.$auth.getPayload().sub, { campaignId })
          }
          dispatch('refresh')
          dispatch(
            'snackbarSuccess',
            alreadyAuthenticated
              ? `Your ${provider.capitalize()} account has been linked to your Leaply account.`
              : `You have been logged in with your ${provider.capitalize()} account.`,
            {
              root: true,
            }
          )
          return response
        },
        // Authentication failure
        error => {
          dispatch(
            'snackbarError',
            `Authentication with ${provider.capitalize()} failed or was abandoned.`,
            {
              root: true,
            }
          )
          return { error }
        }
      )
    },
  },
}
